import TextField, { TextFieldProps } from "@mui/material/TextField";

type FormTextFieldProps = TextFieldProps & {
    isEditing?: boolean;
};

// This is just a wrapper around TextField to add the isEditing logic (shrink the label when editing)
const FormTextField = ({ isEditing, slotProps, ...rest }: FormTextFieldProps) => {
    return (
        <TextField
            {...rest}
            slotProps={{
                ...slotProps,
                inputLabel: {
                    shrink: isEditing ? true : undefined,
                    //...slotProps?.inputLabel,
                },
            }}
        />
    );
}

export default FormTextField;
